<ng-container *ngIf="displayDetails$ | async">
  <h2 class="section-title-with-icon">
    <mat-icon class="section-title-icon notranslate">apartment</mat-icon>
    <span>Asset Details</span>
  </h2>

  <!-- !IMPORTANT: All list items must also be inlcuded in the "propsToCheck" array inside the getAssetDetailsValuesCount() function,
    ! otherwise they will not be counted correctly -->

  <ul class="details-list">
    <!-- Lot size -->
    <li *ngIf="asset.lotSizeArea !== null && asset.lotSizeArea !== undefined">
      <label>Lot Size [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.lotSizeArea | terraNumber }}
    </li>

    <!-- Stories -->
    <li *ngIf="asset.stories !== null && asset.stories !== undefined">
      <label>Number of Floors</label>{{ asset.stories | terraNumber }}
    </li>

    <!-- Residential units -->
    <li *ngIf="asset.residentialUnits !== null && asset.residentialUnits !== undefined">
      <label>Number of Residential Units</label>{{ asset.residentialUnits | terraNumber }}
    </li>

    <!-- Retail units -->
    <li *ngIf="asset.retailUnits !== null && asset.retailUnits !== undefined">
      <label>Number of Retail Units</label>{{ asset.retailUnits | terraNumber }}
    </li>

    <!-- Rooms -->
    <li *ngIf="asset.rooms !== null && asset.rooms !== undefined">
      <label>Number of Rooms</label>{{ asset.rooms | terraNumber  }}
    </li>

    <!--Gross building area -->
    <li *ngIf="asset.grossBuildingArea  !== null && asset.grossBuildingArea !== undefined">
      <label>Gross Building [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.grossBuildingArea | terraNumber }}
    </li>

    <!--Residential Net Sellable Area -->
    <li *ngIf="asset.residentialNetSellableArea  !== null && asset.residentialNetSellableArea !== undefined">
      <label>Residential Net Sellable
        [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.residentialNetSellableArea | terraNumber }}
    </li>

    <!--Retail Net Sellable Area -->
    <li *ngIf="asset.retailNetSellableArea  !== null && asset.retailNetSellableArea !== undefined">
      <label>Retail Net Sellable
        [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.retailNetSellableArea | terraNumber  }}
    </li>

    <!-- Number of sites -->
    <li *ngIf="asset.numberOfSites !== null && asset.numberOfSites !== undefined">
      <label>Number of Sites</label>
      {{ asset.numberOfSites | terraNumber  }}
    </li>

    <!-- custom details -->
     @if (customDetails().length) {
      @for (item of customDetails(); track $index) {
        <li >
          <label>{{ item.name }}</label>
          {{ item.value }}
        </li>
       }
     }

    
  </ul>

<!--  <a class="light link show-all-link" *ngIf="(assetDetailsValuesCount$ | async) > 3"
    (click)="showAll()">Show all asset details
  </a>-->
</ng-container>
